mutation DispatchFetchDocuments(
  $agentRegistrationId: ID!
  $fileNumber: String!
) {
  dispatchFetchDocuments(
    input: {
      agentRegistrationId: $agentRegistrationId
      fileNumber: $fileNumber
    }
  ) {
    workItem {
      id
      databaseId
      status
    }
    errors
  }
}
